export default __webpack_public_path__ + "static/media/other.3931defb.svg";